import { createContext, useState, useEffect, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export const UserContext = createContext({
  setCurrentUser: () => null,
  currentUser: null,
  Tax_types: [],
  setCountRenew: () => null,
  setIsFsLineSetup: () => null
});

// lazy loader (faster)
const getStorage = (key) => {
  const value = localStorage.getItem(key);
  return value ? value : null;
};

const usePathSegment = () => {
  const location = useLocation();

  const pathSegments = useMemo(() => {
    return location.pathname.split("/").filter(Boolean);
  }, [location.pathname]);

  const getSegment = (index) => {
    if (index === "first") return pathSegments[0] || null;
    if (index === "last") return pathSegments[pathSegments.length - 1] || null;
    if (typeof index === "number") return pathSegments[index] || null;
    return null;
  };

  return { getSegment };
};

export const UserProvider = ({ children }) => {
  const navigate = useNavigate();

  const [currentUser, setCurrentUser] = useState(() => getStorage("useSession"));
  const [JWTtoken, setJWTtoken] = useState(() => getStorage("jwtToken"));
  const [username, setUsername] = useState(() => getStorage("username"));
  const [company_id, setCompany_id] = useState(() => getStorage("company_id"));
  const [user_id, setUser_id] = useState(() => getStorage("user_id"));
  const [is_vat, setIs_vat] = useState(() => getStorage("is_vat"));
  const [privelegeUser, setPrivelegeUser] = useState(() => getStorage("privelege"));
  const [positionUser, setpositionUser] = useState(() => getStorage("position"));
  const [ModeEncoder, setModeEncoder] = useState(() => getStorage("ModeEncoder"));
  const [Tax_types, setTax_types] = useState(() => getStorage("Tax_types"));
  const [Trade_name, setTrade_name] = useState(() => getStorage("trade_name"));
  const [Tin, setTin] = useState(() => getStorage("tin"));
  const [Reg_address, setReg_address] = useState(() => getStorage("reg_address"));
  const [VersionApp, setVersionApp] = useState(() => getStorage("VersionApp"));
  const [MaintenanceMode, setMaintenanceMode] = useState(() => getStorage("MaintenanceMode"));
  const [OwnerName, setOwnerName] = useState(() => getStorage("owner_name"));
  const [first_login, setfirst_login] = useState(() => getStorage("first_login"));
  const [count_renew, setfcount_renew] = useState(() => getStorage("count_renew"));
   const [is_branch, setis_branch] = useState(() => getStorage("is_branch"));
  const [is_fsline_setup, setIsFsLineSetup] = useState(() => getStorage("is_fsline_setup"));

  const { getSegment } = usePathSegment();

  useEffect(() => {
    fetch_setup();
    Check_Token_Is_Valid();
    checkSessionExpire();
  }, []);

  useEffect(() => {
    const currentFirst = getSegment("first");

    if (Number(first_login) === 1 && currentFirst !== "register") {
      navigate("/change/password");
    }
  }, [first_login]);

  const checkSessionExpire = () => {
    const storedData = localStorage.getItem("useSession");

    if (!storedData) return;

    const data = JSON.parse(storedData);

    if (Date.now() > data.expiresAt) {
      handleRemove();
    }
  };

  const handleRemove = () => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("useSession");
    setCurrentUser(null);
    setJWTtoken(null);
  };

  const Check_Token_Is_Valid = async () => {
    try {
      const tokenData = localStorage.getItem("jwtToken");

      if (!tokenData) {
        handleRemove();
        return;
      }

      const token = JSON.parse(tokenData).value;

      const response = await fetch(
        process.env.REACT_APP_API_URL + "api/check_is_login",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );

      if (response.status === 401) {
        handleRemove();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetch_setup = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + "api/fetch/setup",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          }
        }
      );

      if (response.status === 201) {
        const data = await response.json();

        setVersionApp(data.version);
        setMaintenanceMode(data.maintenance);

        if (data.maintenance == 1) {
          navigate("/maintainance");
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const Login = (
    responseJWT,
    username,
    company_id,
    user_id,
    is_vat,
    privelege,
    position,
    tax_types,
    trade_name,
    tin,
    reg_address,
    owner_name,
    first_login,
    count_renew,
    is_branch,
    is_fsline_setup
  ) => {
    const data = {
      value: responseJWT,
      expiresAt: Date.now() + 24 * 60 * 60 * 1000
    };

    localStorage.setItem("jwtToken", JSON.stringify(data));
    localStorage.setItem("useSession", JSON.stringify(data));

    setCurrentUser({ sessionIdentifier: JSON.stringify(data) });

    setUsername(username);
    localStorage.setItem("username", username);

    setCompany_id(company_id);
    localStorage.setItem("company_id", company_id);

    setUser_id(user_id);
    localStorage.setItem("user_id", user_id);

    setTax_types(tax_types);
    localStorage.setItem("Tax_types", JSON.stringify(tax_types));

    setIs_vat(is_vat);
    localStorage.setItem("is_vat", is_vat);

    setPrivelegeUser(privelege);
    localStorage.setItem("privelege", privelege);

    setpositionUser(position);
    localStorage.setItem("position", position);

    setTrade_name(trade_name);
    localStorage.setItem("trade_name", trade_name);

    setTin(tin);
    localStorage.setItem("tin", tin);

    setReg_address(reg_address);
    localStorage.setItem("reg_address", reg_address);

    setOwnerName(owner_name);
    localStorage.setItem("owner_name", owner_name);

    setfirst_login(first_login);
    localStorage.setItem("first_login", first_login);

    setfcount_renew(count_renew);
    localStorage.setItem("count_renew", count_renew);

    setIsFsLineSetup(is_fsline_setup);
    localStorage.setItem("is_fsline_setup", is_fsline_setup);


    setis_branch(is_branch);
    localStorage.setItem("is_branch", is_branch);


      console.log(is_branch);

    setModeEncoder("ChangeMode");
    localStorage.setItem("ModeEncoder", "ChangeMode");
  };

  const setCountRenew = (nextCountRenew) => {
    setfcount_renew(nextCountRenew);
    localStorage.setItem("count_renew", nextCountRenew);
  };

  const setFsLineSetup = (nextValue) => {
    setIsFsLineSetup(nextValue);
    localStorage.setItem("is_fsline_setup", nextValue);
  };

  const SignOutAPi = async () => {
    try {
      await fetch(process.env.REACT_APP_API_URL + "/api/authentication/signout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const Logout = () => {
    sessionStorage.clear();
    localStorage.clear();
    setCurrentUser(null);
    handleRemove();
    SignOutAPi();
  };

  return (
    <UserContext.Provider
      value={{
        currentUser,
        JWTtoken,
        username,
        company_id,
        user_id,
        is_vat,
        privelegeUser,
        positionUser,
        ModeEncoder,
        Tax_types,
        Trade_name,
        Tin,
        Reg_address,
        VersionApp,
        MaintenanceMode,
        OwnerName,
        count_renew,
        is_branch,
        is_fsline_setup,
        setCountRenew,
        setIsFsLineSetup: setFsLineSetup,
        setModeEncoder,
        Login,
        Logout
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
